import type { Caractere } from '../tipos';

/**
 * Alfabeto aceito (§4.1). Letras básicas + diacríticos do português.
 * `Ç` e `C` são letras independentes (§4.3) e por isso aparecem separadas.
 */
export const LETRAS_BASICAS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const LETRAS_ACENTUADAS = 'ÁÀÂÃÉÊÍÓÔÕÚÜÇ';

export const ALFABETO: ReadonlySet<string> = new Set([...LETRAS_BASICAS, ...LETRAS_ACENTUADAS]);

export const HIFEN = '-';

/** Limites de tamanho (§4.1 e §4.2). */
export const TAMANHO_MIN_JOGADOR = 1;
export const TAMANHO_MAX_JOGADOR = 12;
export const TAMANHO_MIN_AUTOMATICA = 3;
export const TAMANHO_MAX_AUTOMATICA = 10;

/** Uma letra que recebe sugestão vertical. Hifens não recebem (§5.3). */
export function ehLetraJogavel(caractere: string): boolean {
  return ALFABETO.has(caractere.toUpperCase());
}

export function ehHifen(caractere: string): boolean {
  return caractere === HIFEN;
}

/** Caracteres que podem entrar no draft (§4.1, T01-06). */
export function ehCaractereAceito(caractere: string): boolean {
  return ehLetraJogavel(caractere) || ehHifen(caractere);
}

/**
 * Igualdade de letras do jogo (§4.3):
 * insensível a caixa, sensível a diacrítico.
 *
 * `a` cruza com `A`; `A` não cruza com `Á`; `C` não cruza com `Ç`.
 */
export function mesmaLetra(a: string, b: string): boolean {
  return a.toUpperCase() === b.toUpperCase();
}

/** Uma âncora só pode ser uma letra — hifens são inelegíveis (§4.1, T04-03). */
export function podeSerAncora(caractere: Caractere): boolean {
  return ehLetraJogavel(caractere);
}
